import type { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/src/config";
import { getBridge } from "@/src/lib/bridge/bridge";
import { sleep } from "./sleep";

/** 会员/支付相关 query，购买成功后需失效以拉取最新权益 */
export const MEMBER_INVALIDATE_QUERY_KEYS = [
  [QUERY_KEYS.MEMBER_FEATURE],
  [QUERY_KEYS.MEMBER_USE_PLAN],
  [QUERY_KEYS.MEMBER_FEATURE_EQUITYLIST],
  [QUERY_KEYS.PAYMENT_LIST_PAYMENT],
  [QUERY_KEYS.MEMBER_EQUITY_LIST],
] as const;

/** Retain 弹窗等场景额外失效的 key */
export const MEMBER_RETENTION_EXTRA_INVALIDATE_KEYS = [
  [QUERY_KEYS.MEMBER_RETENTION_STATS],
] as const;

/** 后端会员状态异步落库，invalidate 前等待 */
export const MEMBER_INVALIDATE_DELAY_MS = 2000;

export type MemberInvalidateQueryKey = readonly unknown[];

/** 会员相关 query 根 key（供 `useContainerBroadcastStateSync` 与本地 invalidate 共用） */
export const MEMBER_INVALIDATE_QUERY_ROOTS = MEMBER_INVALIDATE_QUERY_KEYS.map(
  (queryKey) => String(queryKey[0]),
);

/** 多 WebView：通知其它容器失效并拉取会员接口（当前 WebView 由原生排除，不会收到中继） */
export function broadcastMemberUpdatedToOtherShellTabs(
  payload?: Record<string, unknown>,
): void {
  getBridge().broadcastMemberUpdated(payload);
}

export function invalidateMemberQueries(
  queryClient: QueryClient,
  extraKeys: readonly MemberInvalidateQueryKey[] = [],
  options?: { skipCrossWebViewBroadcast?: boolean },
) {
  [...MEMBER_INVALIDATE_QUERY_KEYS, ...extraKeys].forEach((queryKey) => {
    void queryClient.invalidateQueries({ queryKey });
  });
  if (!options?.skipCrossWebViewBroadcast) {
    broadcastMemberUpdatedToOtherShellTabs();
  }
}

export async function invalidateMemberQueriesAfterDelay(
  queryClient: QueryClient,
  delayMs: number = MEMBER_INVALIDATE_DELAY_MS,
  extraKeys: readonly MemberInvalidateQueryKey[] = [],
) {
  await sleep(delayMs);
  invalidateMemberQueries(queryClient, extraKeys);
}
